<!-- ./src/components/shared/NavPills.vue -->
<template>
  <div>
    <ul class="vector-list" ref="elList">
      <li
        class="vector-list-item"
        v-for="item in items"
        :key="item"
        :class="{ active: item === selected }"
        @click="select(item)"
      >
        {{ item }}
      </li>
    </ul>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="bar"
      v-if="showBar"
      :style="barStyle"
      version="1.1"
      width="5px"
      height="2px"
    >
      <rect :width="mwidth" height="2px" :fill="color" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "red"
    }
  },
  data() {
    return {
      selected: "",

      mtop: 0,
      mleft: 0,
      mwidth: 0,
      mheight: 0,

      showBar: false,
      shouldUpdatePosition: false
    };
  },
  updated() {
    this._updatePosition();
    if (this.items.length > 0) {
      this.showBar = true;
    } else {
      this.showBar = false;
    }
  },
  methods: {
    select(item) {
      this.selected = item;
      this._emitValue();
      this.shouldUpdatePosition = true;
    },
    _updatePosition() {
      const tParent = this.$refs.elList;

      const index = this.items.findIndex(el => {
        return el === this.selected;
      });
      const tChild = tParent.children[index];

      if (tChild != null) {
        const child = tChild.getBoundingClientRect();
        const parent = tParent.getBoundingClientRect();

        this.mtop = child.top - parent.top;
        this.mleft = child.left - parent.left;
        this.mwidth = child.width;
        this.mheight = child.height;
      }
      this.shouldUpdatePosition = false;
    },
    _emitValue() {
      this.$emit("select-event", this.selected);
    }
  },
  watch: {
    items(newValue, oldValue) {
      if (newValue.length > 0) {
        this.selected = this.items[0];
        this.shouldUpdatePosition = true;
      } else {
        this.shouldUpdatePosition = false;
        this.showBar = false;
        this.selected = "";
      }
      this._emitValue();
    }
  },
  mounted() {
    if (this.items.length > 0) {
      this.selected = this.items[0];
      this._emitValue();
      this.shouldUpdatePosition = true;
    } else {
      this._emitValue();
    }
  },
  computed: {
    barStyle() {
      const y = this.mheight - 3;
      const x = this.mleft;

      return {
        transform: `translate(${x}px,-${y}px)`,
        width: this.mwidth + "px"
      };
    }
  }
};
</script>

<style scoped>
.vector-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.vector-list-item {
  display: inline;
  margin-right: 15px;
  cursor: pointer;
  opacity: 0.3;
}

#bar {
  transition: all 0.3s linear;
}

.active {
  opacity: 1;
  transition: opacity 0.3s linear;
}
</style>
